import { render, staticRenderFns } from "./ExportEducationProgram.vue?vue&type=template&id=22aa1b9d&"
import script from "./ExportEducationProgram.vue?vue&type=script&lang=js&"
export * from "./ExportEducationProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports